import React from 'react'

const PayoutStructure = () => {
    
    return (
        <div className='agent-card-wrapper'>
            <div className="Payout-title" >
                <div className="left-title">Payout Structure</div>
            </div>
            <div className='payout-details'>
                <div className='payout-section'>
                    <div className='section-left'>
                        <span className='payout-text'>Level:</span>
                        <select className="iba-custom-select payout-select">
                            <option value="L1">L1</option>
                            <option value="L2">L2</option>
                            <option value="L3">L3</option>
                        </select>
                    </div>

                    <div className='section-left'>
                        <span className='payout-text'>New Tier Bonus:</span>
                        <select className="iba-custom-select payout-select">
                            <option value="10000">10000</option>
                            <option value="20000">20000</option>
                            <option value="30000">40000</option>
                        </select>
                    </div>
                </div>
                <div className='payout-section'>
                    <div className='section-left'>
                        <span className='payout-text'>Per Minute:</span>
                        <select className="iba-custom-select payout-select">
                            <option value="1.20">1.20</option>
                            <option value="1.50">1.50</option>
                            <option value="1.70">1.70</option>
                        </select>
                    </div>
                    <div className='section-left'>
                        <span className='payout-text'>Per Account:</span>
                        <select className="iba-custom-select payout-select">
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="300">300</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PayoutStructure